<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <span class="headline">Kategorije Objekata</span>
            <bit-page :breadcrumbs="breadcrumbs"></bit-page>
            <v-row align="center" class="white mt-3 pa-3" no-gutters>
                <span class="title green--text text--darken-3">Kategorije Objekata</span>
                <v-col class="d-flex mb-3" cols="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col class="d-flex mt-3" cols="12">
                    <v-btn depressed small tile color="success"
                           :to="{name: 'kategorije-create', params: {type: 'object'}}">Dodaj novi objekat
                    </v-btn>
                </v-col>

                <v-progress-linear
                        class="my-4"
                        indeterminate
                        color="primary"
                        v-if="loading"
                ></v-progress-linear>

                <v-row justify="end" no-gutters>
                    <v-col cols="12" lg="4" class="mt-3">
                        <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                dense
                                outlined
                                label="Search"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-col class="d-flex" cols="12">
                    <v-treeview
                            v-if="items.length"
                            open-all
                            :items="filteredItems"
                            selection-type="independent"
                            color="warning"
                    >
                        <template v-slot:prepend="{ item }">
                            <span class="overline">ID:{{item.id}}</span>
                        </template>
                        <template v-slot:append="{ item, open }">
                            <v-btn icon
                                   :to="{name: 'kategorije-create', params: {item: {parent: {id: item.id, name: item.name}, langs: []}, type: 'object', sub: true}}">
                                <v-icon small>{{'mdi-plus'}}</v-icon>
                            </v-btn>
                            <v-btn icon :to="{name: 'kategorije-create', params: {item: item, type: 'object'}}">
                                <v-icon small>{{'mdi-pencil'}}</v-icon>
                            </v-btn>
                            <v-btn icon @click="remove(item)">
                                <v-icon small>{{'mdi-delete'}}</v-icon>
                            </v-btn>
                        </template>
                    </v-treeview>
                    <confirm-dialog ref="confirmBox"></confirm-dialog>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
	import bitPage from "../../../components/layout/page";
	import confirmDialog from '../../../components/global/confirm'
	import moment from 'moment'
	import lodash from "lodash-es";
	import addFilterDeep from "deepdash-es/addFilterDeep";
	const _ = addFilterDeep(lodash);

	export default {
		components: {
			bitPage,
			confirmDialog
		},
		head() {
			return {
				title: 'BitLab CMS'
			}
		},
		data: () => ({
			search: '',
			breadcrumbs: [
				{
					text: 'Kategorije Objekata',
					disabled: true
				},
			],
			items: [],
			selected: null,
			loading: false
		}),
		created() {
			this.getObject();
		},
		methods: {
		    getObject() {
                this.loading = true;
                this.items = [];
                this.axios.get(`/category?type=object`)
                    .then(res =>

                        res.data.forEach(item => {
                            let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang);
                            item['name'] = lang && lang.name ? lang.name : '';
                            if (item.children) this.loop(item.children);
                            if (item['name'] !== '') this.items.push(item)
                        })

                    )
                    .finally(() => this.loading = false)
            },
			remove(item) {
				this.$refs.confirmBox.open('Remove category object', 'Are you sure want to delete this category object?')
				.then(() => this.axios.delete(`/category/${item.id}`).then(() => {
					this.items.splice(this.items.indexOf(item), 1)
				}))
			},
            loop(items) {
                items.forEach(item => {
                    let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang);
                    item['name'] = lang && lang.name ? lang.name : '';
                    if (item.children) this.loop(item.children)
                })
            },
		},
		computed: {
            setLang() {
                return this.$store.state.lang.code === 'en'
                    ? 'en' : this.$store.state.lang.code === 'la'
                        ? 'sr' : 'ћи'
            },
			filteredItems() {
				return _.filterDeep(this.items, data => {
					return data.name.toLowerCase().includes(this.search.toLowerCase())
				}, {childrenPath: "children"}) || [];
			}
		},
		filters: {
			date(date) {
				return moment(date).format('DD MMM YYYY')
			}
		},
		watch: {
            setLang() {
                this.getObject();
            },
			selected() {
				this.selected.length > 1 && this.selected.shift()
			}
		}
	}
</script>
